import { CmsRegistrationOrderConfirmationPlanDetailsPanel } from '../../models/registration-order-confirmation/cms-registration-order-confirmation-page-plan-details-panel.interface';

export const mockCmsRegistrationOrderConfirmationPlanDetailsPanel: CmsRegistrationOrderConfirmationPlanDetailsPanel =
  {
    registrationOrderConfirmationPlanDetailsTermsAndConditions:
      'https://wwww.linkToMagnolia.com/pdf',
  };
